import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { DeliveryCity } from '../types/delivery-city.type';
import { CreateDeliveryCityRequestDTO } from '../types/dtos/create-delivery-city.dto';
import { ADMIN_DELIVERY_CITIES_API_PATHS } from '../constants/delivery-cities-api-paths.constants';

type UseCreateDeliveryCityResult = {
  isSubmitting: boolean;
  createDeliveryCity: (data: CreateDeliveryCityRequestDTO) => Promise<DeliveryCity | null>;
};

export function useCreateDeliveryCity(): UseCreateDeliveryCityResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createDeliveryCity = async (data: CreateDeliveryCityRequestDTO): Promise<DeliveryCity | null> => {
    setIsSubmitting(true);

    try {
      const createdDeliveryCity = await HttpClient.post<DeliveryCity, CreateDeliveryCityRequestDTO>(
        ADMIN_DELIVERY_CITIES_API_PATHS.CREATE_DELIVERY_CITY,
        data
      );

      enqueueSnackbar('Ville de livraison créée', { variant: 'success' });
      return createdDeliveryCity;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la création de la ville de livraison'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, createDeliveryCity };
}
